import { motion } from 'framer-motion';
import { Users, Target, Rocket } from 'lucide-react';

interface SocialProofProps {
    signupCount: number;
}

export default function SocialProof({ signupCount }: SocialProofProps) {
    const stats = [
        {
            icon: Users,
            value: signupCount > 0 ? `${signupCount.toLocaleString()}+` : '10,000+',
            label: 'Waitlist Signups',
            color: 'from-primary-500 to-secondary-500',
        },
        {
            icon: Target,
            value: '50+',
            label: 'Dares Ready to Go',
            color: 'from-primary-600 to-primary-700',
        },
        {
            icon: Rocket,
            value: 'Q1 2026',
            label: 'Launch Date',
            color: 'from-secondary-500 to-secondary-600',
        },
    ];

    return (
        <section className="py-20 gradient-bg">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="text-center mb-16"
                >
                    <h2 className="font-display text-4xl sm:text-5xl font-bold text-white mb-4">Join the Movement</h2>
                    <p className="text-xl text-gray-400 max-w-3xl mx-auto">
                        Thousands are already waiting. Don't miss out.
                    </p>
                </motion.div>

                <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
                    {stats.map((stat, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: index * 0.1 }}
                            className="text-center"
                        >
                            <div
                                className={`inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br ${stat.color} rounded-2xl mb-4 shadow-lg`}
                            >
                                <stat.icon className="w-10 h-10 text-white" />
                            </div>
                            <div className="font-display text-4xl sm:text-5xl font-bold text-white mb-2">
                                {stat.value}
                            </div>
                            <div className="text-gray-400 font-medium">{stat.label}</div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
